import React from 'react';
import { styleMapping } from "../utils/tools";
import MenuElement from "../elements/menuElement";
import * as actions from '../../store/pseudo/general';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import notify from "../../services/notify";


class Menu extends React.Component {

    //############################ CONSTRUCTOR ###################################
	//############################ CONSTRUCTOR ###################################
	constructor(props) {
        super(props);
        this.state={menu: null};
    }  

    async componentDidMount(){
        if(this.props.settingsManual){
            const temp = JSON.parse(this.props.settingsManual);
            this.setState({menu: temp});
        } 
        else {this.setState({menu: this.props.settings.menu});}
    }

    UNSAFE_componentWillReceiveProps(props){
        if(props.settingsManual){            
            const temp = JSON.parse(props.settingsManual);
            this.setState({menu: temp});
        }
    }

    normalizePath = (link) => {
        if (!link || link === '') {
            return '/';
        }
        return (link[0] === '/' ? link : '/' + link);
    }

    isMenuActive = (link) => {
        const pathname = ((this.props.location && this.props.location.pathname) ? this.props.location.pathname : '/').toLowerCase();
        const target = this.normalizePath(link).toLowerCase();
        if (target === '/home') {
            return pathname === '/home' || pathname === '/';
        }
        return pathname === target;
    }

    handleItemClick = () => {
        if (this.props.onItemClick) {
            this.props.onItemClick();
        }
    }
    

    copyEmailToClipboard = (email) => {
        navigator.clipboard.writeText(email).then(() => {
            notify.success("Contact email address copied to the clipboard", { autoClose: 1500, title: "Copied", toastId: "contact-email-copied" });
        }).catch(err => {
            notify.error("Failed to copy contact email address", { autoClose: 2400, title: "Clipboard" });
            console.error('Failed to copy email address: ', err);
        });
    }

    // ############################ RENDER ###################################
    // ############################ RENDER ###################################
    render() {
        let menu;
        const { architecture } = this.props;
        
        if(this.state.menu){ menu = this.state.menu; }
        else { menu = this.props.settings.menu; }
        const menuRootStyle = {
            ...styleMapping(menu ? menu.container : {}),
            ...(this.props.forceVertical ? {display: 'block'} : {})
        };
    
        if(menu){
            return ( 
                <div
                    aria-labelledby="dropdownLogo"
                    className={ "BRL Wide100 " + menu.container.class + (this.props.forceVertical ? " side-menu-menu-root" : "")}
                    style={menuRootStyle}
                >
                    <div className="BRL Wide100 InlineBlock">
                        {architecture.menu ? 
                            Object.keys(architecture.menu).map((part, index) => {
                                const menuItem = architecture.menu[part];
                                const linkPath = this.normalizePath(menuItem.link);
                                const isActive = this.isMenuActive(menuItem.link);
                                const customContainerClass = (this.props.custom && this.props.custom.container ? (' ' + this.props.custom.container) : '');
                                const linkClass = 'BRL side-menu-link' + (isActive ? ' is-active' : '') + customContainerClass;
                                return (
                                    <React.Fragment key={index}>
                                        {menuItem['name'] !== 'business' && menuItem['name'] !== 'Contact' &&
                                        <Link
                                            key={index}
                                            className={linkClass}
                                            to={linkPath}
                                            onClick={this.handleItemClick}
                                        >
                                            <MenuElement key={index} class="BRL Hand" index={index} data={menuItem} settings={(this.props.custom ? this.props.custom.element : menu.element)}></MenuElement>
                                        </Link>}
    
                                        {menuItem['name'] === 'Contact' && 
                                        <a
                                            key={index}
                                            className={linkClass}
                                            href={"mailto:contact@strangersapp.cc"}
                                            onClick={() => {
                                                this.copyEmailToClipboard("contact@strangersapp.cc");
                                                this.handleItemClick();
                                            }}
                                        >
                                            <MenuElement key={index} class="BRL Hand" index={index} data={{"name": "contact@strangersapp.cc"}} settings={(this.props.custom ? this.props.custom.element : menu.element)}></MenuElement>
                                        </a>}
                                    </React.Fragment>
                                );
                            })
                        : null
                        }
                    </div>          
                </div>
            );
        }           
    }
}

const mapstateToProps = (state) => {
    return {
        isAuthenticated: state.status.token !== null && state.status.token !== '' ? true : false, 
        status:state.status, 
        user:state.user, 
        settings:state.settings, 
        architecture:state.architecture
    };
}
const mapDispatchToProps = dispatch => {
    return {
        navigate: (direction, history) => dispatch(actions.navigate(direction, history)), 
        sideMenuFunction: (bVal) => dispatch(actions.sideMenu(bVal))
    }
}
export default withRouter(connect(mapstateToProps, mapDispatchToProps)(Menu));

